import React from "react";
import { Button, Divider, Typography } from "@mui/material";
import UiFormControlSelection from "../../common/ui/UiFormControlSelection";
import LinkNavigate from "../../../assets/icons-svg/link-navigate.svg";

export default function FederalTaxesForm({ filingStatus = [] }) {
  return (
    <>
      <UiFormControlSelection
        label="Filing Status (Required)"
        type="select"
        optionsData={filingStatus}
        labelClass="federal-taxes__filingStatus"
        optionKey=""
        optionValue=""
        fieldName="filing_status"
        showFloatingLabel={true}
      ></UiFormControlSelection>

      <div className="federal-taxes__dependentAmount">
        <UiFormControlSelection
          type="number"
          placeholder="Number of Dependents(Optional)"
          label="Number of Dependents(Optional)"
          fieldName="dependents_amount"
          showFloatingLabel={true}
        />
        <p className="federal-taxes__dependentAmount--description">
          A dependent is a person other than the taxpayer or spouse who entitles
          the taxpayer to claim a dependency exemption.
        </p>
      </div>
      <UiFormControlSelection
        type="currency"
        placeholder="Other Income (Optional)"
        label="Other Income (Optional)"
        fieldName="other_income"
        showFloatingLabel={true}
        labelClass="federal-taxes__otherIncome"
      />

      <div className="federal-taxes__multipleJobs">
        <Typography variant="h6">Do you have multiple jobs?</Typography>
        <UiFormControlSelection
          type="toggle"
          optionsData={[
            { value: "Yes", label: "Yes" },
            { value: "No", label: "No" },
          ]}
          fieldName="two_jobs"
        />

        <p className="federal-taxes__multipleJobs--description">
          Examples of this are if you and your spouse each have a job, or if you
          have two jobs.
        </p>

        <Divider />
      </div>
      <div className="federal-taxes__deductions">
        <Typography className="" variant="h6">
          Deductions
        </Typography>
        <p className="federal-taxes__deductions--description">
          Any expenses that you can write off to lower your tax liability.
        </p>

        <div className="federal-taxes__deductions--learn-more">
          <span>Learn More:</span>
          <Button variant="outlined" className="btn-link">
            <a
              href="https://www.irs.gov/individuals/tax-withholding-estimator"
              target="_blank"
              className="primary-link"
            >
              www.irs.gov
            </a>
            <img src={LinkNavigate} />
          </Button>
        </div>
        <UiFormControlSelection
          type="currency"
          placeholder="Deduction Amount (Optional)"
          label="Deduction Amount (Optional)"
          fieldName="deductions"
          showFloatingLabel={true}
        />

        <Divider />
      </div>
      <div className="federal-taxes__extraWithHoldings">
        <Typography className="" variant="h6">
          Extra Withholdings
        </Typography>
        <p className="federal-taxes__extraWithHoldings--description">
          You can request an additional amount to be withheld from each
          paycheck.
        </p>
        <div>
          <UiFormControlSelection
            type="currency"
            fieldName="extra_withholding"
            placeholder="Withholding Amount (Optional)"
            label="Withholding Amount (Optional)"
            showFloatingLabel={true}
          />
        </div>
      </div>
    </>
  );
}
